import type { BlockDefinition, Template } from '@tsagko/label-contracts'
import { bakeBlock } from '../template-designer/bake-block'
import { mergeVariables } from './variables-ops'

/**
 * Synthesises a single-instance preview Template from a BlockDefinition.
 *
 * - dims match the block exactly (widthMm/heightMm)
 * - the root zone holds one baked instance occupying the full label
 * - variable defaults are applied (same as committing a drop with no explicit values)
 */
export function blockPreviewTemplate(block: BlockDefinition): Template {
  // Build a values map from the canonical variable set's defaults.
  // mergeVariables returns the full metadata map (layout refs + persisted meta),
  // so iterating it gives us every variable that might appear in the layout.
  const variables = mergeVariables(block.layout, block.variables ?? {})
  const defaultValues: Record<string, string> = {}
  for (const [name, meta] of Object.entries(variables)) {
    if (meta.default !== undefined && meta.default !== '') {
      defaultValues[name] = meta.default
    }
  }

  // bakeBlock applies variable substitution (same path as commitDrop with {}).
  // Passing defaultValues explicitly mirrors "drop with defaults" semantics.
  const baked = bakeBlock(block, defaultValues)

  return {
    id: `__block-preview__${block.id}`,
    name: block.name,
    widthMm: block.widthMm,
    heightMm: block.heightMm,
    rootZone: {
      id: 'preview-root',
      component: baked,
    },
  }
}
